import React from "react";
import translate from "../../constants/translations";
import FileAttachment from "./file-attachment";
import type { Attachment, CustomerContext } from "../../types";

interface FileAttachmentsListProps {
	cultureCode: string;
	customer: CustomerContext;
	attachments: Attachment[];
}

export default function FileAttachmentsList({
	customer,
	cultureCode,
	attachments,
}: FileAttachmentsListProps) {
	const t = (term: string) => translate(cultureCode, term);

	if (!attachments.length) {
		return null;
	}

	return (
		<div className="if row u-margin-top--small">
			<div className="if col-10--sm">
				<h5 className="if heading">{t("AttachmentsHeader")}</h5>
				{attachments.map((attachment) => (
					<FileAttachment
						customer={customer}
						cultureCode={cultureCode}
						attachment={attachment}
						key={attachment.attachmentId}
					/>
				))}
			</div>
		</div>
	);
}
